import { ICompanies } from 'search/classes/models/ICompanies'
import { ICompanyInfo } from 'search/classes/models/ICompanyInfo'
import { read, save } from 'search/store'
import { StoreForms } from 'search/store/state'
import { IFetchResult } from 'src/core/classes/helpers/store/Interfaces'
import { HttpCancel } from 'src/core/classes/http'

import {
  fetchCompanies,
  fetchCompanyInfo,
  fetchStory,
  setCompanies,
  setCompanyInfo,
} from './api/CompanySearchApi'

export class CompanySearchStoreService {
  public loading: Promise<void>

  public constructor() {
    this.loading = new Promise<void>((resolve) => {
      this.loadingResolver = resolve
    })
  }

  public loadingResolver: () => void = () => {}

  public init = async (
    pid: string,
    cancelObject: HttpCancel
  ): Promise<IFetchResult<ICompanies>> => {
    const storeQuery = `story=${JSON.stringify([pid])}`
    let story = read(StoreForms.companies, storeQuery)
    if (!story) {
      story = await fetchStory(pid, cancelObject)
      if (!cancelObject.canceled && story.total) {
        save(StoreForms.companies, storeQuery, story)
      }
    }

    return story
  }

  public getCompanies = async (
    query: string,
    pid: string,
    cancelObject: HttpCancel
  ): Promise<IFetchResult<ICompanies>> => {
    const storeQuery = JSON.stringify([query, pid])
    let companies = read(StoreForms.companies, storeQuery)
    if (!companies) {
      companies = await fetchCompanies(query, pid, cancelObject)
      if (!companies['items'].length) {
        const map = new window['google'].maps.Map(document.createElement('div'))
        const request = {
          query,
        }
        const service = new window['google'].maps.places.PlacesService(map)
        const { results, status }: any = await new Promise((resolve) =>
          service.textSearch(request, (results: any, status: any) => resolve({ results, status }))
        )
        if (status === window['google'].maps.places.PlacesServiceStatus.OK) {
          return await this.saveCompanies(query, pid, results, storeQuery, cancelObject)
        }
        return { items: [], total: 0 }
      }
      if (!cancelObject.canceled && companies.total) {
        save(StoreForms.companies, storeQuery, companies)
      }
    }

    return companies
  }

  public saveCompanies = async (
    query: string,
    pid: string,
    rows: any,
    storeQuery: string,
    cancelObject: HttpCancel
  ): Promise<IFetchResult<ICompanies>> => {
    const data = {
      SearchString: query,
      Rows: rows,
      PID: pid,
    }
    const companies = await setCompanies(data, cancelObject)
    if (!cancelObject.canceled) {
      save(StoreForms.companies, storeQuery, companies)
    }
    return companies
  }

  public getCompanyInfo = async (
    placeId: string,
    pid: string,
    cancelObject: HttpCancel
  ): Promise<IFetchResult<ICompanyInfo>> => {
    const storeQuery = JSON.stringify([placeId, pid])
    let companyInfo = read(StoreForms.companyInfo, storeQuery)
    if (!companyInfo) {
      companyInfo = await fetchCompanyInfo(placeId, pid, cancelObject)
      if (!companyInfo['items'].length) {
        const map = new window['google'].maps.Map(document.createElement('div'))
        const request = {
          placeId,
        }
        const service = new window['google'].maps.places.PlacesService(map)
        const { results, status }: any = await new Promise((resolve) =>
          service.getDetails(request, (results: any, status: any) => resolve({ results, status }))
        )
        if (status === window['google'].maps.places.PlacesServiceStatus.OK) {
          return await this.saveCompanyInfo(placeId, pid, results, storeQuery, cancelObject)
        }
        return { items: [], total: 0 }
      }
      if (!cancelObject.canceled && companyInfo.total) {
        save(StoreForms.companyInfo, storeQuery, companyInfo)
      }
    }

    return companyInfo
  }

  public saveCompanyInfo = async (
    id: string,
    pid: string,
    rows: any,
    storeQuery: string,
    cancelObject: HttpCancel
  ): Promise<IFetchResult<ICompanyInfo>> => {
    const data = {
      PlaceId: id,
      GoogleId: rows['id'],
      Rows: rows,
      PID: pid,
    }
    const companyInfo = await setCompanyInfo(data, cancelObject)
    if (!cancelObject.canceled) {
      save(StoreForms.companyInfo, storeQuery, companyInfo)
    }
    return companyInfo
  }
}

const companySearchStoreService = new CompanySearchStoreService()
export { companySearchStoreService }
